import { render, staticRenderFns } from "./ProductIndex.vue?vue&type=template&id=0c59cea1&lang=pug"
import script from "./ProductIndex.vue?vue&type=script&lang=js"
export * from "./ProductIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports